import React, { useEffect, useState } from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import cmsApi from "../services/cmsApi";

const AthleticsNews = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadAthleticsNews = async () => {
      try {
        setLoading(true);
        setError("");
        const result = await cmsApi.getNews({ limit: 50 });
        if (result.success && Array.isArray(result.news)) {
          const athleticsNews = result.news
            .filter((item) => (item.category || "").toLowerCase() === "athletics")
            .map((item) => ({
              id: item.id,
              title: item.title,
              date: item.date || "",
              summary: item.excerpt || item.description || "",
            }));
          setArticles(athleticsNews);
          if (!athleticsNews.length) setError("No athletics news available right now.");
        } else {
          setError("Unable to load athletics news right now.");
        }
      } catch {
        setError("Unable to load athletics news right now.");
      } finally {
        setLoading(false);
      }
    };
    loadAthleticsNews();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mid-desktop-page">

      <section className="py-16 bg-gradient-to-r from-custom-pink to-purple-600 text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            Athletics News & Stories
          </h1>
          <p className="text-lg sm:text-xl max-w-3xl mx-auto">
            Simple blog-style updates about JR Institute athletics. This page
            is intentionally minimal and easy to maintain.
          </p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          {loading && <p className="text-center text-gray-500 py-8">Loading athletics news...</p>}
          {!loading && error && articles.length === 0 && (
            <p className="text-center text-gray-500 py-8">{error}</p>
          )}
          {articles.map((article) => (
            <article
              key={article.id}
              className="border-b border-gray-200 pb-6 mb-6 last:border-b-0 last:pb-0 last:mb-0"
            >
              <h2 className="text-2xl font-bold text-gray-900 mb-1">
                {article.title}
              </h2>
              <p className="text-sm text-gray-500 mb-2">{article.date}</p>
              <p className="text-gray-700">{article.summary}</p>
            </article>
          ))}
        </div>
      </section>

      </div>

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default AthleticsNews;


